import { useEffect, useState } from 'react'

interface OnboardingMessages {
  welcomeMessage: string
  useCases: { label: string; message: string }[]
}

const DEFAULT_ONBOARDING_MESSAGES: OnboardingMessages = {
  welcomeMessage: 'Welcome! Let’s get you set up — what will you use Highlight for?',
  useCases: [
    {
      label: 'School',
      message:
        'Nice! I can help with research, writing, problem-solving, and more. Create an account to finish setup — or just ask me anything to get started.',
    },
    {
      label: 'Work',
      message:
        'Let’s get to work. I can help draft emails, plan your day, analyze info, or tackle big projects. Create an account to finish setup — or jump right in.',
    },
    {
      label: 'Personal Life',
      message:
        'Love it. I can help with planning, learning, hobbies — or just thinking things through. Create an account to personalize Highlight, or start chatting now.',
    },
  ],
}

const useRemoteOnboardingMessages = async () => {
  try {
    const response = (await fetch('https://cdn.highlightai.com/config/onboarding-use-case.json')) as Response
    const data = (await response.json()) as OnboardingMessages
    return data
  } catch (error) {
    console.error('Error fetching onboarding settings:', error)
    return null
  }
}

export const useOnboardingMessages = (step: 'name' | 'use-case') => {
  const isMac = process.platform === 'darwin'

  const NAME_MESSAGE: OnboardingMessages = {
    welcomeMessage: `I'm Highlight, your desktop assistant that works across every app on your computer. I'm here to help you get things done faster.\n\nHighlight can automatically understand any window you have focused. Try one of the suggestions below or press ${isMac ? '⌘ + N' : 'Ctrl + N'} to start a new chat.`,
    useCases: [], // No longer using static use cases - will be dynamic based on user context
  }
  const [isLoading, setIsLoading] = useState(true)
  const [onboardingMessages, setOnboardingMessages] = useState<OnboardingMessages | null>(NAME_MESSAGE)

  useEffect(() => {
    const fetchOnboardingMessages = async () => {
      // const messages = await useRemoteOnboardingMessages()
      setOnboardingMessages(NAME_MESSAGE)
      setIsLoading(false)
    }
    fetchOnboardingMessages()
  }, [step])

  return { onboardingMessages, isLoading }
}
